import { MatchHeight } from 'js-match-height';

const init = () => {
  new MatchHeight('ul.ResourceList-topic-list li.ResourceList-topic-item');
};

// Init on initial page load
init();

